import SearchIcon from "@mui/icons-material/Search";

import InputText, { PropsType } from "commons/ui/input/InputText";

function SearchInput(props: PropsType) {
    return (
        <InputText
            {...props}
            className={"search-input-filter"}
            startAdornment={
                <div className={"search-icon-start-adornment"}>
                    <SearchIcon />
                </div>
            }
        />
    );
}

export default SearchInput;
